import { AuthApi } from '../Authentication/Authentication'; // eslint-disable-line import/no-cycle
import { getData, setData, removeKey as removeCash } from '../Cache';
import DXLInstance from '../DXL/DXL'; // eslint-disable-line import/no-cycle
import { requestApi, config } from '../Network/Network';

import CachePolicy from './utilities/CachePolicy';
import InternetConnection from './utilities/InternetConnection';

async function execute(request, networkCachePolicy = { policy: CachePolicy.NETWORK_ONLY }) {
  if (request) {
    if (networkCachePolicy.policy === CachePolicy.CACHE_EXISTS) {
      const generatedKey = _generateKey(request);
      return getData(generatedKey)
        .then(result => {
          if (result) {
            return Promise.resolve(result);
          } else {
            if (!isNaN(networkCachePolicy.expiration)) {
              return callApi(request).then((response, error) => {
                if (response) {
                  setData(generatedKey, response, networkCachePolicy.expiration);
                  return Promise.resolve(response);
                } else {
                  return Promise.reject(error);
                }
              });
            }
          }
        })
        .catch(error => {
          return Promise.reject(error);
        });
    } else {
      return callApi(request);
    }
  }
}
function _generateKey(request) {
  return JSON.stringify(request);
}
async function callApi(request) {
  const isConnected = await InternetConnection.checkConnection();
  if (isConnected) {
    return requestApi(request)
      .then(result => Promise.resolve(result))
      .catch(error => Promise.reject(error));
  }
  return false;
}
const setCash = setData;
const getCash = getData;
const CACHE_POLICY = CachePolicy;
const DXL = DXLInstance;

export { execute, CACHE_POLICY, setCash, getCash, removeCash, config, AuthApi, DXL };
